import { TableColumn } from "@kyan/ui";

import { ReferralsSummary } from "#/types/referrals";

import { OverviewCell } from "./components/OverviewCell";

export const getColumns = (): TableColumn<ReferralsSummary>[] => [
  {
    id: "totalReferrals",
    cell: (row) => (
      <OverviewCell title="Total Referrals" value={row.totalReferrals} />
    ),
  },
  {
    id: "activeReferrals",
    cell: (row) => (
      <OverviewCell title="Active Referrals" value={row.activeReferrals} />
    ),
  },
  {
    id: "totalVolume",
    cell: (row) => (
      <OverviewCell
        isCurrency
        value={row.totalVolume}
        title="Total Referred Vol"
      />
    ),
  },
  ...Array.from({ length: 1 }, (_, index) => ({
    id: `empty-${index}`,
  })),
];
